var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-user-info"},[_c('carat',{attrs:{"carat":_vm.carat}}),_vm._v(" "),_c('about-carat',{staticClass:"about-carat",on:{"click":function($event){return _vm.$emit('open-about-mycolor')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }